import { MapAsync } from "../async/MapAsync"
import { StringToUInt8 } from "../bytes/StringToUInt8"
import type { AsyncSequence } from "../types/AsyncSequence"
import type { GUID } from "../types/GUID"
import { UInt8Hash } from "./UInt8Hash"

export async function StringHash(stream: AsyncSequence<string>): Promise<GUID> {
  return UInt8Hash(MapAsync(StringToUInt8, stream))
}
